module.exports = __webpack_public_path__ + "static/media/1.279288ae.jpg";